var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_93",
    "data-name": "Layer 93",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M19,5H18V3a1,1,0,0,0-2,0V5H8V3A1,1,0,0,0,6,3V5H5A3,3,0,0,0,2,8V9H22V8A3,3,0,0,0,19,5Z",
    transform: "translate(-2 -2)",
    fill: "#a8a8a8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M2,19a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V11H2Z",
    transform: "translate(-2 -2)",
    fill: "#a8a8a8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateicon);
export default __webpack_public_path__ + "static/media/dateicon.32aa9e43cccb43a3cac04803e46eb285.svg";
export { ForwardRef as ReactComponent };